import n from"styled-components";import{theme as o}from"../../../theme.js";const i=n.div`
  background-color: ${o.colors.secondary[900]};
  width: 100%;
  > div {
    width: ${o.maxWidth};
    margin: auto;
    justify-content: center;
    display: flex;
    gap: ${o.spacing*4}px;
    align-items: center;
    padding: ${o.spacing*2}px 0;
    box-sizing: border-box;
    > span {
      color: ${o.colors.shades[0]};
    }
    > button {
      outline: none;
      cursor: pointer;
      border: none;
      background-color: #ffffff29;
      text-transform: uppercase;
      color: ${o.colors.shades[0]};
      border-radius: ${o.radius}px;
      padding: ${o.spacing*2}px ${o.spacing*4}px;
      font-weight: 700;
      font-size: 12px;
    }
    @media screen and (max-width: ${o.breakpoints.xl}) {
      width: 100%
    }
    @media screen and (max-width: ${o.breakpoints.md}) {
      gap: ${o.spacing*2}px;
      flex-direction: column;
      align-items: flex-start;
      padding: ${o.spacing*2}px ${o.spacing*4}px;
    }
  }
`;export{i as Container};
